import React, { useEffect, useState } from "react";
import axios from "axios";
import "./Gallery.css";

const Gallery = () => {
  const [folders, setFolders] = useState([]);
  const [ungroupedImages, setUngroupedImages] = useState([]);
  const [activeTab, setActiveTab] = useState("all");
  const [lightboxImages, setLightboxImages] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState(null);

  useEffect(() => {
    axios
      .get("/api/gallery")
      .then((res) => {
        const namedFolders = [];
        const others = [];

        res.data.folders.forEach((folder) => {
          if (!folder.name || folder.name.trim() === "") {
            others.push(...folder.images);
          } else {
            namedFolders.push(folder);
          }
        });

        setFolders(namedFolders);
        setUngroupedImages([...others, ...res.data.ungroupedImages]);
      })
      .catch((err) => console.error("Fetch error", err));
  }, []);

  const getAllImages = () => {
    const folderImages = folders.flatMap((folder) =>
      folder.images.map((img) => ({ ...img, folderName: folder.name }))
    );
    const ungrouped = ungroupedImages.map((img) => ({
      ...img,
      folderName: "Others",
    }));
    return [...folderImages, ...ungrouped];
  };

  const getCurrentImages = () => {
    if (activeTab === "all") {
      return getAllImages();
    }
    const folder = folders.find((f) => f._id === activeTab);
    return folder
      ? folder.images.map((img) => ({
          ...img,
          folderName: folder.name,
        }))
      : [];
  };

  const openLightbox = (imgList, index) => {
    setLightboxImages(imgList);
    setSelectedIndex(index);
  };

  const closeLightbox = () => setSelectedIndex(null);
  const prevImage = () =>
    setSelectedIndex((prev) =>
      prev > 0 ? prev - 1 : lightboxImages.length - 1
    );
  const nextImage = () =>
    setSelectedIndex((prev) =>
      prev < lightboxImages.length - 1 ? prev + 1 : 0
    );

  const currentImages = getCurrentImages();

  return (
    <div className="gallery-wrapper">
       <div
        className="jumbotron jumbotron-fluid page-header position-relative overlay-bottom"
        style={{ marginBottom: '30px' }}
      >
        <div className="container text-center py-5" style={{ marginTop: "-80px" }}>
          <h1 className="text-white display-1">Gallery</h1>
          <div className="d-inline-flex text-white mb-5">
            <p className="m-0 text-uppercase">
              <a className="text-white" href="">Home</a>
            </p>
            <i className="fa fa-angle-double-right pt-1 px-3"></i>
            <p className="m-0 text-uppercase">Gallery</p>
          </div>

          
        </div>
      </div>
    

      {/* Tabs */}
      <div className="category-tabs">
        <button
          className={`category-btn ${activeTab === "all" ? "active" : ""}`}
          onClick={() => setActiveTab("all")}
        >
          All
        </button>
        {folders.map((folder) => (
          <button
            key={folder._id}
            className={`category-btn ${
              activeTab === folder._id ? "active" : ""
            }`}
            onClick={() => setActiveTab(folder._id)}
          >
            {folder.name}
          </button>
        ))}
      </div>

      {/* Images */}
      <div className="image-grid">
        {currentImages.map((img, index) => (
          <div className="image-box flip-card" key={img._id}>
            <div
              className="flip-inner"
              onClick={() => openLightbox(currentImages, index)}
            >
              <div className="flip-front">
                <img
                  src={`${img.url}`}
                  alt={`gallery-${index}`}
                />
              </div>
              <div className="flip-back">
                <p>{img.text || "No description"}</p>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Lightbox */}
      {selectedIndex !== null && (
        <div className="lightbox" onClick={closeLightbox}>
          <span className="close">&times;</span>
          <span
            className="nav left"
            onClick={(e) => {
              e.stopPropagation();
              prevImage();
            }}
          >
            &#10094;
          </span>
          <span
            className="nav right"
            onClick={(e) => {
              e.stopPropagation();
              nextImage();
            }}
          >
            &#10095;
          </span>
          <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
            <img
              src={`${lightboxImages[selectedIndex].url}`}
              alt="Large"
            />
            <p>{lightboxImages[selectedIndex].text}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default Gallery;
